import { observable } from "mobx";
import { createContext, useContext } from "react";
import packageJson from '../../package.json';
import { isBrowser, isDevelopment } from "../env";
import { CLOCK, ClockController } from "./clock.controller";
import { makeStoreController, StoreController } from "./store.controller";
import { makeUIController, UIController } from "./ui.controller";
import { makeWishlistController, WishlistController } from "./wishlist.controller";

const makeSiteInfo = () => ({
  name: packageJson.name,
  version: packageJson.version,
})

export type AppController = {
  siteInfo: ReturnType<typeof makeSiteInfo>,
  UI: UIController,
  CLOCK: ClockController,
  WISHLIST: WishlistController,
  STORE: StoreController,
}

const makeAppController = () => {
  const c: AppController = observable({
    siteInfo: makeSiteInfo(),
    UI: makeUIController(),
    STORE: makeStoreController(),
    WISHLIST: makeWishlistController(),
    CLOCK,
  })
  c.UI.init(c);
  c.STORE.init(c);
  c.WISHLIST.init(c);
  if (isDevelopment && isBrowser) {
    Reflect.set(window, 'ROOT', c);
    Reflect.set(window, 'UI', c.UI);
    Reflect.set(window, 'STORE', c.STORE);
    Reflect.set(window, 'WISHLIST', c.WISHLIST);
    Reflect.set(window, 'CLOCK', c.CLOCK);
  }
  if (isBrowser) {
    document.documentElement.setAttribute('data-version', c.siteInfo.version);
  }
  return c;
}

export const AppController = makeAppController();

export const AppContext = createContext(AppController);

export const useAppContext = () => useContext(AppContext);

export const useControllers = useAppContext;